import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    context: 'ruleset',
    viewPath: props.viewPath,
    path: 'custom_payment_plan_ruleset.min_downpayment_type',
  })
  return function onClick() {
    change('amount')
  }
}
